export default "__VITE_ASSET__13114226__"